import * as React from 'react'
import { observer } from 'mobx-react'
import { TeamListViewModel } from '../TeamListViewModel'
import { SplitViewHeader, SplitViewHeaderSearch } from 'components/SplitView'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TeamListViewModel
  scrollOffset: ScrollOffsetInterpolation
}

export default observer(function TeamListHeader({ vm, scrollOffset }: Props) {
  return (
    <SplitViewHeader compact scrollOffset={scrollOffset}>
      <SplitViewHeaderSearch
        value={vm.searchText}
        onChange={vm.setSearchText}
        placeholder="Search Teams"
      />
    </SplitViewHeader>
  )
})
